import { CloseIcon, SearchIcon } from '@synergy/theme-next';
import { IconButton, InputAdornment, InputBase, InputBaseProps, styled, useTheme } from '@mui/material';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

const StyledInput = styled(InputBase)(({ theme }) => ({
    ...theme.typography.body1,
    padding: '13px 8px 13px 16px',
    borderRadius: 4,
    height: 48,

    [theme.breakpoints.up('sm')]: {
        borderLeft: `1.5px solid ${theme.palette.common.black}`,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
}));

export type SearchInputProps = InputBaseProps & {
    onClear?: () => void;
    value?: string;
};

export const SearchInput = (props: SearchInputProps): ReactElement => {
    const { onClear, ...inputProps } = props;
    const intl = useIntl();
    const theme = useTheme();

    return (
        <StyledInput
            {...inputProps}
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon
                        sx={{
                            color: inputProps.value ? theme.palette.common.black : theme.palette.grey[700],
                        }}
                    />
                </InputAdornment>
            }
            endAdornment={
                !!props.value && (
                    <InputAdornment position="end">
                        <IconButton onClick={onClear}>
                            <CloseIcon sx={{ color: theme.palette.grey[700] }} />
                        </IconButton>
                    </InputAdornment>
                )
            }
            placeholder={intl.formatMessage({ id: 'app.searchBar.placeholder' })}
        />
    );
};
